/* eslint-disable react/no-danger */
import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import classnames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import selectDataForAlert from 'shared/product_tabs/alert/selector';
import { dismissAlert } from 'shared/product_tabs/alert/alertSlice';

const Alert = () => {
  const dispatch = useDispatch();
  const { show, alert } = useSelector(selectDataForAlert);
  if (!show || !alert) return null;

  const { variant, title, message } = alert;

  const onHide = () => {
    dispatch(dismissAlert());
  };

  const className = classnames({
    'bg-danger text-white': variant === 'danger',
    'bg-success text-white': variant === 'success',
    'bg-warning text-dark': variant === 'warning',
  });

  return (
    <Modal onHide={onHide} show={show}>
      <Modal.Header className={className}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div dangerouslySetInnerHTML={{ __html: message }} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide}>
          {Spree.translations.close}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Alert;
